const Constants = {
  drawerWidth: 240,
}

export default Constants
